<template>
  <FilterBar :is-loading="loading" class="ml-auto">
    <template #prefilter>
      <FilterSearch
        :active-search="searchTerm"
        :loading="loading"
        input-label="Search Templates"
        @update-search="({ searchTerm }) => updateSearchTerm(searchTerm)"
        @set-page="updatePage(1)"
      />
    </template>
    <template #toggle-filter:extended="{ isDisabled }">
      <FilterToggle
        class="mr-2"
        label="Active Only"
        :model-value="isActiveOnly"
        :is-disabled="isDisabled"
        @update:model-value="$event => updateIsActiveOnly($event, router)"
      />
    </template>
    <template #submenu>
      <CreateModalTrigger
        :page-name="route.name"
        :disabled="!authData.canEditTemplates"
      />
    </template>
  </FilterBar>
</template>

<script setup>
import FilterBar from '@/components/filter/FilterBar.vue';
import CreateModalTrigger from '@/components/settings/components/CreateModalTrigger.vue';
import { useRoute, useRouter } from 'vue-router';
import FilterToggle from '@/components/filter/filterMenu/FilterToggle.vue';
import { storeToRefs } from 'pinia';
import { useTemplates } from '@/stores/settings/templates';
import { useAppAuthData } from '@/stores/app/authData';
import FilterSearch from '@/components/filter/filterMenu/FilterSearch.vue';

// Route
const route = useRoute();
const router = useRouter();

const { isActiveOnly, searchTerm } = storeToRefs(useTemplates());
const {
  updateIsActiveOnly,
  updatePage,
  updateSearchTerm,
} = useTemplates();
const { authData } = storeToRefs(useAppAuthData());

defineProps({
  loading: {
    type: Boolean,
    default: true,
  },
});
</script>
